

















import _ from 'lodash';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Station } from '@/models/station.model';
import { Options } from '@/models/app.model';

@Component({
  name: 'SimpleSelect',
})
export default class SimpleSelect extends Vue {
  @Prop() public model!: string[];
  @Prop() public options!: Options<string>[];
  @Prop() public disabled?: boolean;
  @Prop() public label?: string;
  @Prop({ default: false }) public multiple?: boolean;

  public innerModel: string[] = [];

  @Emit()
  public onChanged() {
    return this.innerModel;
  }

  public mounted() {
    this.onModelChange();
  }

  @Watch('model')
  public onModelChange() {
    this.innerModel = _.clone(this.model);
  }

  public onChange() {
    this.$emit('update:model', this.innerModel);
    this.onChanged();
  }
}
